import { useCallback, useMemo, useState } from 'react';
import { addDays } from 'date-fns';
import useApiFetch from '@/hooks/useApiFetch';
import candidatesReports from '@/services/candidatesReports';
import { FetchApiIds } from '@/types';
import {
  defaultChartPeriod,
  getPercentageFromBiggestNumber,
  today,
  newCandidateColors,
} from '@/utils/chart';
import NewByOwnerChartComponent from './NewByOwnerChart.component';

const NewByOwnerChartContainer = function (): JSX.Element {
  const [selectedFilter, setSelectedFilter] = useState(today);
  const periodOptions = defaultChartPeriod(selectedFilter);

  const onSelectFilter = useCallback((value: string): void => {
    setSelectedFilter(value);
  }, []);

  const newCandidatesByOwner = useApiFetch(
    [FetchApiIds.NEW_CANDIDATES_BY_OWNER, selectedFilter, today],
    () => {
      const updatedHour = new Date(selectedFilter);
      const updatedTo = addDays(new Date(today), 1);
      updatedHour.setHours(0, 0, 0, 0);
      return candidatesReports.getNewCandidatesByOwners({
        status: 'NEW,PENDING',
        startDate: updatedHour.toISOString(),
        endDate: updatedTo.toISOString(),
      });
    }
  );

  const data = useMemo(() => {
    const results = newCandidatesByOwner.data?.totalOfCandidatesByOwner ?? [];
    const resultsWithColors = results.map((owner, index) => {
      return {
        ...owner,
        color: newCandidateColors[index],
      };
    });

    return getPercentageFromBiggestNumber(resultsWithColors);
  }, [newCandidatesByOwner.data?.totalOfCandidatesByOwner]);

  return (
    <NewByOwnerChartComponent
      data={data}
      onSelectFilter={onSelectFilter}
      periodOptions={periodOptions}
      isLoading={newCandidatesByOwner.isLoading}
    />
  );
};

export default NewByOwnerChartContainer;
